import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    failedItemsText: (itemCount: number) => string;
    unsupportedItemsText: (itemCount: number) => string;
    details: string;
    detailsLinkText: string;
    additionalItems: (itemCount: number) => string;
    confirmButton: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Dialog title showing count of items that failed to upload */
            failedItemsText: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (itemCount: number): string => __intl__.intl().formatMessage({ id: "FailedItemsDialog.failedItemsText?c=255yl3s2ap39s", defaultMessage: "{itemCount, plural, one {1 Item} other {{itemCount} Items}} failed to upload" }, { itemCount: itemCount }));
                },
                enumerable: true,
                configurable: true
            },
            /** Dialog title showing count of unsupported items */
            unsupportedItemsText: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (itemCount: number): string => __intl__.intl().formatMessage({ id: "FailedItemsDialog.unsupportedItemsText?c=1u44xzvh1y7ho", defaultMessage: "{itemCount, plural, one {1 Item} other {{itemCount} Items}} not supported for upload" }, { itemCount: itemCount }));
                },
                enumerable: true,
                configurable: true
            },
            /** Dialog description explaining why items can't be uploaded */
            details: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FailedItemsDialog.details?c=3oi31yhh3yzuu", defaultMessage: "Some unsupported items cannot be uploaded." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Link text to learn more about supported items */
            detailsLinkText: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FailedItemsDialog.detailsLinkText?c=3fhz05p6u9amp", defaultMessage: "Learn more \u2197" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Text showing count of additional items not displayed */
            additionalItems: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (itemCount: number): string => __intl__.intl().formatMessage({ id: "FailedItemsDialog.additionalItems?c=1aii68sk3li4t", defaultMessage: "+ {itemCount, plural, one {1 Item} other {{itemCount} Items}}" }, { itemCount: itemCount }));
                },
                enumerable: true,
                configurable: true
            },
            /** Confirm button text to dismiss the dialog */
            confirmButton: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FailedItemsDialog.confirmButton?c=3kgms7gn8i2kv", defaultMessage: "OK" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
